import React from 'react';
import { FontWeights, mergeStyleSets, Text } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMailPecMail } from '../../shared/interfaces';
import AppUtilities from '../../shared/Utilities/appUtilities';
import { StatoSpedizioneEnum } from '../../shared/enums';

const styles = mergeStyleSets({
    subject: {
        marginBottom: 12,
        fontWeight: FontWeights.regular,
    },
    from: {
        display: 'block',
        marginTop: 20,
    },
    body: {
        display: 'block',
        marginTop: 20,
    },
    toAndDate: {
        display: 'block',
        marginTop: 5,
        fontWeight: FontWeights.light
    }
});
export interface PecMailItemCellProps {
    pecMailItem: IMailPecMail
}
type Props = PecMailItemCellProps



const PecMailItemCell: React.FunctionComponent<Props> = props => {

    // metodi per la restituzione delle icone in base allo stato
    const setStatoSpedizioneIconClasses = (statoSpedizione: StatoSpedizioneEnum) => {

        if (statoSpedizione === StatoSpedizioneEnum.Completata) {
            return ("msgCompletato")

        } else if (statoSpedizione === StatoSpedizioneEnum.CompletataConErrori || statoSpedizione === StatoSpedizioneEnum.NonAccettata) {
            return ("msgCompletatoConErrori")

        } else if (statoSpedizione === StatoSpedizioneEnum.InAttesa) {
            return ("msgInAttesa")
        }

        return "";
    }

    const setStatoSpedizioneIcon = (statoSpedizione: StatoSpedizioneEnum) => {

        switch (statoSpedizione) {

            case StatoSpedizioneEnum.InAttesa:
                return (
                    <FontAwesomeIcon
                        className={'stato-spedizione fa-xs'}
                        icon={{ prefix: 'fas', iconName: 'hourglass-start' }}
                    />
                )

            case StatoSpedizioneEnum.NonAccettata:
            case StatoSpedizioneEnum.CompletataConErrori:
                return (
                    <FontAwesomeIcon
                        className={'stato-spedizione fa-xs'}
                        icon={{ prefix: 'fas', iconName: 'exclamation' }}
                    />
                )

            case StatoSpedizioneEnum.Completata:
                return (
                    <FontAwesomeIcon
                        className={'stato-spedizione fa-xs'}
                        icon={{ prefix: 'fas', iconName: 'check' }}
                    />
                )

        }
    }

    const showStatoSpedizione = (statoSpedizione: StatoSpedizioneEnum) => {
        switch (statoSpedizione) {

            case StatoSpedizioneEnum.InAttesa:
            case StatoSpedizioneEnum.NonAccettata:
            case StatoSpedizioneEnum.CompletataConErrori:
            case StatoSpedizioneEnum.Completata:
                return true;
            default:
                return false;
        }

    }
    return (
        <>
            <div className="mail-item" id={`cell-${props.pecMailItem.id}`}>

                {showStatoSpedizione(props.pecMailItem.statoSpedizione) &&
                    <div className="row1">
                        <div className="stato-spedizione">
                            <div className={setStatoSpedizioneIconClasses(props.pecMailItem.statoSpedizione)}>
                                {setStatoSpedizioneIcon(props.pecMailItem.statoSpedizione)}
                                <p className="stato-text">{props.pecMailItem.statoSpedizione}</p>
                            </div>
                        </div>
                    </div>
                }

                <div className="row2">

                    <Text className="mail-from" block nowrap>
                        {props.pecMailItem.from}
                    </Text>

                    <div className="mail-info-ico">
                        {
                            props.pecMailItem.hasAttachments &&
                            <FontAwesomeIcon size="lg" icon={{ prefix: 'fal', iconName: 'paperclip' }} />
                        }
                    </div >
                </div>

                <div className="row3">
                    {props.pecMailItem.subject &&
                        <Text className="mail-subject" nowrap>
                            {props.pecMailItem.subject}
                        </Text>
                    }
                    {!props.pecMailItem.subject &&
                        <Text className="mail-subject" nowrap>
                            [Nessun oggetto]
                        </Text>
                    }
                    <Text className="mail-date" nowrap>
                        {AppUtilities.FormatDate(props.pecMailItem.date, true)}
                    </Text>
                </div>

                <div className="row4">
                    {props.pecMailItem.bodyPreview &&
                        <Text className="mail-body" block nowrap>
                            {props.pecMailItem.bodyPreview}
                        </Text>
                    }
                    {!props.pecMailItem.bodyPreview &&
                        <Text className="mail-body" block nowrap>
                            [Nessun messaggio]
                        </Text>
                    }
                </div>

            </div >
        </>

    );

}
export default PecMailItemCell;

